<template>
  <div class="players">
    <table>
      <thead>
        <tr>
          <td>🏆</td>
          <td>Players</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="player in players" :key="player.name">
          <td>{{player.score}}</td>
          <td>
            {{player.name}}
            <span
              v-if="player.name === turn"
              class="status"
            >telling a clue</span>
            <span
              v-if="gameState.roundPhase === 'SELECTING' && !player.selectedCard"
              class="status"
            >selecting a card</span>
            <span v-if="gameState.roundPhase === 'VOTING' && !player.votedCard" class="status">choosing a card</span>
            <!-- <span class="status">{{player.cards.length}} cards</span> -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "PlayersList",
  computed: {
    ...mapState(["gameState"]),
    ...mapGetters(["players", "localPlayer", "turn"])
  }
};
</script>

<style scoped>
.players {
  flex-grow: 1;
  width: 100%;
  color: white;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.players::-webkit-scrollbar {
    display: none;
}
.players table {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
}
.players thead {
  background: rgba(255, 255, 255, 0.1);
}
.players td {
  height: 50px;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.players td:first-child {
  padding-left: 20px;
  color: #A09FA7;
  width: 20px;
  text-align: center;
}
.players td:last-child {
  padding-right: 20px;
}
.status {
  display: inline-block;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 0 10px;
  height: 20px;
  line-height: 20px;
  margin-left: 10px;
}
</style>